// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"888":"d5ca101a397108af","946":"8c68d6113632810f"}[chunkId] + ".css";
};